import React from 'react';
import PropTypes from 'prop-types';
import {SectionMenu} from '@learningblocks/exp-components';

export class NotebookSectionsList extends React.Component {
  renderSectionList = () => {
    return this.props.sections.map((listitem) => (
      <SectionMenu
        key={listitem.number}
        goToSection={this.props.goToSection}
        {...listitem}
      />
    ));
  };
  render() {
    return (
      <div className='notebook-sections__body'>
        <ul className='sections-list'>{this.renderSectionList()}</ul>
      </div>
    );
  }
}
NotebookSectionsList.propTypes = {
  sections: PropTypes.array.isRequired,
  goToSection: PropTypes.func.isRequired,
};
